var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter_black_18dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 217,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "0309\\u66F4\\u65B0-\\u9996\\u9875",
    transform: "translate(-635.000000, -1993.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9",
    transform: "translate(0.000000, 1972.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter_black_18dp",
    transform: "translate(635.000000, 20.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-twitter-1",
    transform: "translate(3.333333, 5.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.3333333,2.36771944 C22.4748611,2.76968827 21.5522222,3.04040197 20.5838889,3.16242822 C21.5726389,2.53794094 22.3319444,1.54840033 22.68875,0.369155045 C21.7641667,0.947497949 20.7394444,1.36792453 19.6486111,1.59454471 C18.7765278,0.613207547 17.5311111,0 16.1544444,0 C13.06375,0 10.7926389,3.0414274 11.4906944,6.19872847 C7.51333333,5.98851518 3.98611111,3.97867104 1.62458333,0.923913043 C0.370416667,3.19319114 0.974166667,6.16181296 3.10527778,7.66509434 C2.32166667,7.63843314 1.58277778,7.41181296 0.938194444,7.03342904 C0.885694444,9.37243642 2.47527778,11.5607055 4.7775,12.0477851 C4.10375,12.240566 3.36583333,12.285685 2.61527778,12.1339212 C3.22388889,14.1396637 4.99138889,15.5988515 7.0875,15.6398687 C5.075,17.3041427 2.53944444,18.04758 0,17.7317473 C2.11847222,19.164274 4.63555556,20 7.33833333,20 C16.2263889,20 21.2479167,12.0826497 20.9445833,4.98154225 C21.8798611,4.26886792 22.6916667,3.37981952 23.3333333,2.36771944 Z",
    id: "\\u8DEF\\u5F84"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2bf6cbdeac96bc9832a6bf713d8582c8.svg";
export { ForwardRef as ReactComponent };